export default "__VITE_ASSET__D9qleZbK__"